import { Outlet, useLocation } from "react-router-dom";

import Header from "./Header";
import Footer from "./Footer";

export default function Layout() {
  const { pathname } = useLocation();

  return (
    <div className="app-container app-theme-white flex flex-col w-full px-8 text-gray-700 bg-white">
      <div className="flex flex-1">
        <div className="flex-1 sm:min-w-sm lg:px-8 flex sm:items-center sm:justify-center" style={{ flexDirection: "column" }}>
          <div
            className="app-login-box flex-1 sm:flex-initial relative w-full sm:max-w-sm  mx-auto flex flex-col bg-white sm:shadow sm:rounded overflow-hidden"
            style={{
              minHeight: "75vh",
              maxHeight: "75vh",
              minWidth: "30%",
            }}>
            {["/success", "/failed"].includes(pathname) ? <></> : <Header />}
            <Outlet />
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}
